module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content grid",
    class: "layout-" + _vm.layout
  }, [(_vm.name) ? _c('div', {
    staticClass: "title"
  }, [_c('ed-title-nav', {
    attrs: {
      "title": _vm.name,
      "subtitle": _vm.desc
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "search bar"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.search) ? _c('ed-input', {
    ref: "quickSearch",
    staticClass: "search-box",
    attrs: {
      "placeholder": _vm.$t("Search in") + " " + _vm.name,
      "search": ""
    },
    on: {
      "change": _vm.quickSearch
    },
    model: {
      value: (_vm.searchTerm),
      callback: function($$v) {
        _vm.searchTerm = $$v
      },
      expression: "searchTerm"
    }
  }) : _vm._e()], 1), (_vm.permissionsMix[_vm.$root.currentModule]) ? _c('div', {
    staticClass: "col-md-6 actions-bar"
  }, [("export" in _vm.permissionsMix[_vm.$root.currentModule]) ? _c('ed-button', {
    staticClass: "btn btn-actionbar",
    on: {
      "click": _vm.exportList
    }
  }, [_vm._v("Export")]) : _vm._e(), _c('span', _vm._l((_vm.permissionsMix[_vm.$root.currentModule]), function(permission, key) {
    return ((permission === null && _vm.selectedRows.length || permission) && key != "export") ? _c('ed-button', {
      key: key,
      staticClass: "btn btn-actionbar",
      attrs: {
        "to": key
      }
    }, [_vm._v(_vm._s(key))]) : _vm._e()
  }))], 1) : _vm._e()])])])])]), _c('div', {
    staticClass: "filter bar"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('ed-select', {
    staticClass: "inline",
    attrs: {
      "options": _vm.savedViews
    }
  }), (_vm.filters.length) ? _c('i', {
    staticClass: "separator"
  }) : _vm._e(), _c('ul', {
    staticClass: "filters"
  }, [_vm._l((_vm.filters), function(filter) {
    return _c('li', {
      staticClass: "filter"
    }, [_c('i', {
      staticClass: "fas fa-times-circle del-icon",
      on: {
        "click": function($event) {
          _vm.removeFilter(filter)
        }
      }
    }), _c('a', {
      staticClass: "filter",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editFilter(filter)
        }
      }
    }, [_vm._v(_vm._s(filter.label))])])
  }), (_vm.filters.length) ? _c('li', [_c('a', {
    staticClass: "filter clear",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeFilters($event)
      }
    }
  }, [_vm._v("clear all")])]) : _vm._e()], 2)], 1)])])]), _c('div', {
    staticClass: "row grid"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('column-selector', {
    attrs: {
      "columns": this.columnDefs,
      "api": _vm.gridOptions.columnApi
    }
  }), _c('ag-grid-vue', {
    staticClass: "ag-fresh",
    class: {
      "all-rows-selected": !!_vm.allRowsSelected
    },
    staticStyle: {
      "width": "100%",
      "height": "350px"
    },
    attrs: {
      "endpoint": _vm.endpoint,
      "gridOptions": _vm.gridOptions,
      "enableColResize": _vm.resizing
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95077a30","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grid/index.vue
// module id = ey2m
// module chunks = 13 14